




























































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';

import Customer, { customerInitValue } from '@/types/customer/Customer';
import UserInterface from '@/types/app/IUser';
import CustomerService from '@/services/customerService';
import { getFileNameFromLink } from '@/utils/fileName';
import formatDate from '@/utils/formatDate';
import Endpoint from '@/utils/endpoint';

import ModalSuccess from '@/components/common/ModalSuccess.vue';
import ErrorService from '@/services/erroService';
import BaseComponent from '@/utils/baseComponent';
import { Watch } from 'vue-property-decorator';
const namespace = 'customer';
@Component({
  components: { ModalSuccess },
  data: () => ({
    isLCM: false,
    endpoint: new Endpoint(),
    required: (v: any) => !!v || 'This field is required'
  }),
})
export default class ModalCreateInterets extends BaseComponent {
  @Getter('getModalCreateInterestState', { namespace })
  modalCreateInterestState!: boolean;
  @Action('setModalCreateInterestState', { namespace })
  setModalCreateInterestState!: any;
   @Action('setLoading', { namespace }) setLoading!: any;
  @Action('setCustomer', { namespace }) setCustomer!: any;
  @Getter('getCustomer', { namespace }) customer!: Customer;
  @Getter('getUser', { namespace: 'auth' }) user!: UserInterface;
  @Action('setCustomers', { namespace }) setCustomers!: any;
  @Action('removeCustomerFromList', { namespace })
  removeCustomerFromList!: any;
  @Action('setModalRefuseState', { namespace })
  setModalRefuseState!: any;

  openSuccessModal = false;
  loading = false;
  getFileNameFromLink = getFileNameFromLink;
  formatDate = formatDate;
  isLCM = false;
  private endpoint = new Endpoint();
  valid = true;
  customerService = new CustomerService(this.$http);
  errorCreate = false;
  errorMessage!: string;
  isEdit = false;
  get isView() {
    return this.customer.id?.length > 0 && !this.isEdit;
  }

  get isNew() {
    return this.customer.id?.length == 0 && !this.isEdit;
  }

  getInvestorType(value: number): string {
    return [
      'As a Natural Person',
      'As a Corporate, Foundation, Endowment, Company or LLC',
      'As a Trust, Bank, Savings and Loan (or similar Institution) or Insurance Company',
      'Via an Employee Benefit Plan, Individual Retirement Account, or Keogh Plan',
    ][value];
  }

  getClassification(value: number): string {
    return ['Us Person', 'Non Us Person', 'All'][value];
  }

  async createInterest() {
    if (!this.form().validate()) {
      return false;
    }
    try {
      this.errorCreate = false;
      this.loading = true;
      const result = await this.customerService.saveInterest(this.customer);
      
      if (result.hasError === false) {        
        this.openSuccessModal = true;
        this.closeModal();
      } else {
        this.errorMessage = result.messageError;
        this.errorCreate = true;
      }
    } catch (error) {
      ErrorService.onError(error);
    } finally {
       this.loading = false;
    }


  }

  openExternalLink(link: string): void {
    if (link == null) return;
    window.open(link, '_blank');
  }

  showRefusement(): void {
    this.setModalRefuseState(true);
  }

  clear() {
    this.setCustomer(customerInitValue);
    this.errorMessage = '';
    this.errorCreate = false;
    this.loading = false;
  }

  closeModal(): void {
    this.form().reset();
   this.form().resetValidation();
    this.isEdit = false;
    this.setModalCreateInterestState(false);
    this.clear();
  }
}
